import { Pipe, PipeTransform } from '@angular/core';
import { Material } from '../classes/material.class';
import { RawMaterial } from '../classes/raw-material.class';

@Pipe({
    name: 'nonMainRawMaterials',
    standalone: false,
})
export class NonMainRawMaterialsPipe implements PipeTransform {
    transform(material: Material | null): RawMaterial[] {
        return material?.raw_materials?.filter(rm => rm.material_type?.main === false) || [];
    }
}
